<template>
  <infinite-list-autocomplete
    :selectedName="selectedCorporation"
    :data="getCorporationsList"
    :listSearchParams="searchParams"
    :totalCount="totalCount"
    :loading="loading"
    :placeholder="$t('components.corporationSelect.selectCorporation')"
    :disabled="disabled"
    :clearable="isClearable"
    @selectItem="selectItem"
    @intersect="increaceIntersection"
    @clear="selectedCorporation = null"
  >
    <template v-slot:prependIcon>
      <department-icon/>
    </template>
    <template v-slot:appendIcon>
      <v-icon>mdi-chevron-down</v-icon>
    </template>
  </infinite-list-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconLoader } from '@/helpers/iconsLoader';
import { getRoles } from '@/mixins/authentication.mixins';
import { CHANNEL_ADMIN } from '@/helpers/userRoles';
import InfiniteListAutocomplete from '@/components/elements/InfiniteListAutocomplete.vue';

const defaultState = {
  page: 0,
  maxPerPage: 10,
  sort: 'name',
};

export default {
  name: 'corporations-selector',
  mixins: [getRoles],
  components: {
    InfiniteListAutocomplete,
    ...iconLoader.sideMenu,
  },
  props: {
    setSelected: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
    },
    prefill: {
      type: Boolean,
      required: false,
      default: true,
    },
    isClearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedCorporation: null,
      searchParams: defaultState,
      totalCount: 0,
      loading: false,
    };
  },
  async mounted() {
    if (!this.getCorporationsList.length) await this.loadData();

    if (this.getSelectedCorporationId) {
      this.setCorporation();
      return true;
    }

    if (this.getCorporationsList.length) {
      if (!this.prefill) {
        this.loading = false;
        return false;
      }

      if (localStorage.getItem('corporationName')) {
        await this.loadPreselectedCorporation();
      } else {
        this.selectedCorporation = this.getCorporationsList[0].id;
      }
    }

    return true;
  },
  computed: {
    ...mapGetters('corporations', ['getSelectedCorporationId', 'getCorporationsList']),
  },
  watch: {
    getSelectedCorporationId: {
      handler() {
        this.setCorporation();
      },
    },
    selectedCorporation(val) {
      if (this.setSelected) this.$store.commit('corporations/setCorporationId', val);
    },
  },
  methods: {
    selectItem(val) {
      this.$emit('onSelectedItem', val);
      if (val) {
        this.selectedCorporation = val.id;
        this.loading = false;
        return true;
      }
      this.selectedCorporation = null;
      return false;
    },
    setCorporation() {
      const corporation = this.getCorporationsList.find((el) => el.id === this.getSelectedCorporationId);

      if (corporation) {
        this.selectedCorporation = corporation.id;
        this.loading = false;
      } else {
        this.increaceIntersection();
      }
    },
    async increaceIntersection() {
      this.searchParams.page += 1;
      this.intersection = true;
      await this.loadData();

      if (!this.selectedCorporation && !this.hasAccess(CHANNEL_ADMIN)) {
        this.setCorporation();
      }
    },
    formatHeaders(headers) {
      return Number(headers['x-total-count'] || 0);
    },
    async loadData() {
      this.loading = true;
      const updatedData = this.getCorporationsList;
      const { data, headers } = await this.$store.dispatch('corporations/listCorporations', { ...this.searchParams });

      if (!this.totalCount) this.totalCount = this.formatHeaders(headers);

      if (this.intersection) {
        updatedData.push(...data.filter((el) => !updatedData.find((item) => item.id === el.id) && el.status === 'active'));
      }

      this.$store.commit('corporations/setCorporations', updatedData.length ? updatedData : data.filter((el) => el.status === 'active'));
      this.loading = false;
    },
    async loadPreselectedCorporation() {
      const { data } = await this.$store.dispatch('corporations/listCorporations',
        { ...this.searchParams, name: localStorage.getItem('corporationName') });

      if (data.length) {
        this.selectedCorporation = data.find((el) => el.name === localStorage.getItem('corporationName')).id;

        this.$store.commit('corporations/setCorporations', [...data, ...this.getCorporationsList]);
      }
    },
  },
};
</script>
